import { FC } from "react";
import styles from "./Contacts.module.scss";
import { phoneFormatter } from "../../utils/telephoneMask";
import { YMaps, Map, Placemark } from "@pbe/react-yandex-maps";

const CENTER = [56.807373, 59.909832];

interface ContactsProps {
  classess?: string;
}

const Contacts: FC<ContactsProps> = ({ classess }) => {
  return (
    <div className={styles.Contacts}>
      <div className={styles.address}>
        <span>
          <strong>Наш адресс:</strong> ул. Максима Горького 2
        </span>
        <span>
          <strong>Телефон:</strong>{" "}
          <a href="tel:89222137555">{phoneFormatter("89222137555")}</a>
        </span>
        <span>
          <pre>
            <strong>График работы:</strong> Пн, Cр, ПТ 14:00 - 20:00, Вт 10:00 -
            17:00, Чт 14:00-17:00
          </pre>
        </span>
      </div>

      <YMaps>
        <div className={styles.map}>
          <Map
            width={"100%"}
            height={400}
            defaultState={{ center: CENTER, zoom: 17 }}
          >
            <Placemark geometry={CENTER} />
          </Map>
        </div>
      </YMaps>
    </div>
  );
};

export default Contacts;
